const pageTitle = {
  'Youtube Live Shopping': 'YouTube ショッピングを連携',
};

export default pageTitle;
